import { render, staticRenderFns } from "./ViewAcademyVisitorWaiver.vue?vue&type=template&id=5ba05eb8&scoped=true"
import script from "./ViewAcademyVisitorWaiver.vue?vue&type=script&lang=js"
export * from "./ViewAcademyVisitorWaiver.vue?vue&type=script&lang=js"
import style0 from "./ViewAcademyVisitorWaiver.vue?vue&type=style&index=0&id=5ba05eb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba05eb8",
  null
  
)

export default component.exports